export default __webpack_public_path__ + "static/media/Eran Spahbed Spara.7aa4bf47.jpg";